export default __webpack_public_path__ + "static/char-s-40-en-5a6ce6d1e40377a33df996742dea57c2.webp";